import { Component, OnInit } from '@angular/core';
import { SapiService } from '../../../services/sapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITimelineApp } from 'app/components/shared/interactivity-editor/redux/timeline-data.model';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
	selector: 'template-redirect',
	template: `{{ errorMessage }}`
})

export class TemplateRedirectComponent implements OnInit {
	errorMessage = '';
	constructor(protected sapiService: SapiService,
		private route: ActivatedRoute,
		private router: Router) {
	}

	ngOnInit() {
		const id = this.route.snapshot.params.id;
		if (id) {
			this.sapiService.get('app', id).pipe(
				catchError((error) => of(null))
			).subscribe((data) => {
				if (!data) {
					this.errorMessage = `Template ${id} doesn't exist`;
					return;
				}
				const app: ITimelineApp = data;
				const tlid = app.timelines && app.timelines[0] && app.timelines[0].id;
				if (tlid) {
					this.router.navigate(['library/interactivity', tlid]);
				} else {
					this.errorMessage = 'Couldn\'t find a timeline for this template:' + app.name;
				}
			});
		}
	}
}
